import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { switchMap, map, catchError, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { LiveNursesService } from 'src/app/recruiting/candidates/live-nurses-new/live-nurses.service';
import * as actions from '../live-nurses.actions';
import { ToasterService } from 'src/app/shared/services/toaster.service';

@Injectable()
export class PostedJobEffect {
    getPostedJob$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actions.loadLiveNursesPostedJob),
            switchMap((action) => {
                return this.liveNursesService.getPostedJob(action.jobId).pipe(
                    map((response) =>
                        actions.loadLiveNursesPostedJobSuccess({
                            postedJob: response
                        })
                    ),
                    catchError((error) => of(actions.loadLiveNursesPostedJobFail({ error })))
                );
            })
        )
    );

    getPostedJobFail$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(actions.loadLiveNursesPostedJobFail),
                tap((action) => {
                    console.log(action.error);
                    this.toaster.toast('Sorry. A problem occurred while loading Job Details.');
                })
            ),
        { dispatch: false }
    );

    constructor(
        private readonly actions$: Actions,
        protected readonly liveNursesService: LiveNursesService,
        private readonly toaster: ToasterService
    ) {}
}
